import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Grid, { GridProps } from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  gridGutter: {
    [theme.breakpoints.only('xs')]: {
      padding: '0 3px !important', // 6px gutter
    },

    [theme.breakpoints.only('sm')]: {
      padding: '0 7px !important', // 14px gutter
    },

    [theme.breakpoints.only('md')]: {
      padding: '0 12px !important', // 24px gutter
    },

    [theme.breakpoints.up('lg')]: {
      padding: '0 16px !important', // 32px gutter
    },
  },
});

const useStyles = makeStyles(styles);

export default function GridItem({ hasGutter = true, ...props }: GridProps & { hasGutter?: boolean }) {
  const classes = useStyles();
  const { children, className, ...rest } = props;

  return (
    <Grid
      item
      {...rest}
      className={cx(className ?? '', hasGutter && classes.gridGutter)}
    >
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
